export const PivotControl = {
  DateHierarchy: "DateHierarchy",
  DatePeriodPicker: "DatePeriodPicker",
  FilterBy: "FilterBy",
  Measure: "Measure",
  SegmentSelectMulti: "SegmentSelectMulti",
  SegmentFilter: "SegmentFilter",
  StoreAsDefault: "StoreAsDefault",
  ShowSettings: "ShowSettings",
  EnableChartView: "EnableChartView",
  Download: "Download",
  PostFilterByHardcodedColumns: "PostFilterByHardcodedColumns",
  IncludeAtomicPurchasePlan: "IncludeAtomicPurchasePlan",
  EditModeToggle: "EditModeToggle",
} as const;
